import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';
/* eslint-disable max-len */

export interface IRoutesAdditionalBookingSectionsAttributes extends IModelAttributes {
	routesId: string;
	additionalBookingSectionsId: string;

	routes: Models.RouteEntity | Models.IRouteEntityAttributes;
	additionalBookingSections: Models.AdditionalBookingSectionEntity | Models.IAdditionalBookingSectionEntityAttributes;
}

@entity('RoutesAdditionalBookingSections')
export default class RoutesAdditionalBookingSections
	extends Model
	implements IRoutesAdditionalBookingSectionsAttributes
{
	@observable
	@attribute()
	public routesId: string;

	@observable
	@attribute()
	public additionalBookingSectionsId: string;

	@observable
	@attribute({ isReference: true })
	public routes: Models.RouteEntity;

	@observable
	@attribute({ isReference: true })
	public additionalBookingSections: Models.AdditionalBookingSectionEntity;

	constructor(attributes?: Partial<IRoutesAdditionalBookingSectionsAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.routesId) {
				this.routesId = attributes.routesId;
			}
			if (attributes.additionalBookingSectionsId) {
				this.additionalBookingSectionsId = attributes.additionalBookingSectionsId;
			}

			if (attributes.routes) {
				if (attributes.routes instanceof Models.RouteEntity) {
					this.routes = attributes.routes;
					this.routesId = attributes.routes.id;
				} else {
					this.routes = new Models.RouteEntity(attributes.routes);
					this.routesId = this.routes.id;
				}
			} else if (attributes.routesId !== undefined) {
				this.routesId = attributes.routesId;
			}

			if (attributes.additionalBookingSections) {
				if (attributes.additionalBookingSections instanceof Models.AdditionalBookingSectionEntity) {
					this.additionalBookingSections = attributes.additionalBookingSections;
					this.additionalBookingSectionsId = attributes.additionalBookingSections.id;
				} else {
					this.additionalBookingSections = new Models.AdditionalBookingSectionEntity(
						attributes.additionalBookingSections,
					);
					this.additionalBookingSectionsId = this.additionalBookingSections.id;
				}
			} else if (attributes.additionalBookingSectionsId !== undefined) {
				this.additionalBookingSectionsId = attributes.additionalBookingSectionsId;
			}
		}
	}
}
